var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "premium-feature-introduce" }, [
    _c("div", { staticClass: "premium-feature-introduce-title" }, [
      _vm._v(_vm._s(_vm.title)),
    ]),
    _c(
      "div",
      { staticClass: "premium-feature-introduce-description" },
      [
        _vm._t("description", function () {
          return [
            _c("div", { domProps: { innerHTML: _vm._s(_vm.description) } }),
          ]
        }),
      ],
      2
    ),
    _c("div", { staticClass: "premium-feature-introduce-button" }, [
      _c(
        "button",
        { staticClass: "button", on: { click: _vm.onSubscriptionLinkClick } },
        [
          _vm._v(
            " " +
              _vm._s(_vm.$t("historyManageDialog.premiumGuide.checkPlans")) +
              " "
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }